"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Product =
/** @class */
function () {
  function Product(raw) {
    this.productId = raw.productId;
    this.productNameTH = raw.productNameTH;
    this.productNameEN = raw.productNameEN;
    this.productDescriptionTH = raw.productDescriptionTH;
    this.productDescriptionEN = raw.productDescriptionEN;
    this.productSKUId = raw.productSKUId;
    this.productPhoto = raw.productPhoto;
    this.productPrice = raw.productPrice;
    this.originalProductPrice = raw.originalProductPrice;
    this.promoStatus = raw.promoStatus;
    this.promoStartDateTime = raw.promoStartDateTime;
    this.promoEndDateTime = raw.promoEndDateTime;
    this.isOffline = raw.isOffline;
    this.nextOpenDateTime = raw.nextOpenDateTime;
    this.productQCStatus = raw.productQCStatus;
    this.productRejectReason = raw.productRejectReason;
    this.productWeightProduct = raw.productWeightProduct;
    this.productSizeProduct = raw.productSizeProduct;
    this.productPerpackProduct = raw.productPerpackProduct;
    this.productPurchasingAmountLimit = raw.productPurchasingAmountLimit;
    this.tagId = raw.tagId;
  }

  return Product;
}();

exports.Product = Product;